import type { ReactNode } from "react";

import { ProfessionalAuthProvider } from "../shared/auth";
import { LocaleProvider } from "../shared/i18n";
import { CaseStateProvider } from "../shared/state";
import { TelemetryProvider } from "../shared/telemetry";

export function AppProviders({ children }: { children: ReactNode }) {
  return <LocaleProvider><TelemetryProvider><CaseStateProvider><ProfessionalAuthProvider>{children}</ProfessionalAuthProvider></CaseStateProvider></TelemetryProvider></LocaleProvider>;
}
